<template>
  <div>
    <wc-data-box
      title='Connected Companies'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      :loading='isLoading'
      showHelp
      :helpText='helpText'
      showAdd
      @add='edit'
    >
      <v-simple-table dense v-if='contacts.length'>
        <tbody>
          <tr v-for='(contact, index) in contacts' :key='index'>
            <td @click='edit(contact)'>{{ contact.position + ' for ' + contact.client_obj.name_display }}</td>
            <td :class='dataValue'>
              <v-btn icon small @click='openCompany(contact.client_obj.id)'>
                <v-icon color='info' small>mdi-open-in-new</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-else>None found...</v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='(clientContactCopy.id ? "Edit" : "Add New") + " Contact to Company Relationship"'
      icon='mdi-account'
      @cancel='cancel'
      @save='save'
      :disableButtons='!isFormValid || isLoading'
      :loadingButtons='isLoading'
    >
      <template v-slot:dialog-actions v-if='clientContactCopy.id'>
        <v-btn text @click='showConfirmDelete=true' color='error'>Delete</v-btn>
      </template>
      <v-card-text class='mb-4 warning--text'>
        If this individual works for a company, please set that in the basics box.
      </v-card-text>
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <client-form-search
              ref='clientPicker'
              v-model='clientContactCopy.client'
              label='Choose a Company'
              :company='true'
              required
              @loading='setLoading'
            ></client-form-search>
            <!-- <v-autocomplete
              :loading='gettingContactList'
              :items='contactsPickList'
              item-value='id'
              item-text='name_display'
              :rules='[rules.required]'
              label="Choose a Company"
              v-model='clientContactCopy.client'
              :menu-props='{ top: true }'
              :persistent-hint='gettingContactList'
              :hint='gettingContactList ? "getting contacts data" : "start typing to filter results"'
            ></v-autocomplete> -->
          </v-col>
          <v-col cols='12'>
            <v-text-field
              label='Role'
              :rules='[rules.required]'
              v-model='clientContactCopy.position'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

    <wc-confirm
      :showDialog='showConfirmDelete'
      @cancel='showConfirmDelete = false'
      @confirm='deleteClientContact'
      :loading='isDeleting'
    >
      Are you sure you want to delete this contact to company link?
    </wc-confirm>

  </div>
</template>

<script>
import _ from 'lodash'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import clientsAPI from '@/modules/clients/api/clients'
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch'

export default {
  name: 'client-contacts',
  mixins: [formRules],
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    // gettingContactList: false,
    showConfirmDelete: false,
    isDeleting: false,
    showDialog: false,
    isFormValid: false,
    contacts: [],
    // contactsPickList: [],
    showCard: false,
    contactIcon: 'mdi-account-circle',
    dataValue: 'text-right pr-2',
    contact: {},
    clientContactCopy: {},
    helpText: 'Companies that these individuals are connected to (but may not work for)' 
  }),
  computed: {

  },
  mounted () {
    this.getContacts()
  },
  methods: {
    async getContacts () {
      this.isLoading = true
      this.contacts = await clientsAPI.getConnectedClients(this.client)
      this.isLoading = false
    },
    cancel () {
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.showDialog = false
    },
    async save () {
      this.isLoading = true
      this.clientContactCopy.contact = this.client.id
      if (this.clientContactCopy.id) {
        let tmp = await clientsAPI.updateClientContact(this.clientContactCopy)
        this.contacts = miscServices.replaceObject(this.contacts, tmp)
      } else {
        let tmp = await clientsAPI.createClientContact(this.clientContactCopy)
        this.contacts.push(tmp)
      }
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.showDialog = false
      this.isLoading = false
    },
    async edit(contact = null) {
      if (contact) {
        this.clientContactCopy = _.cloneDeep(contact)
      } else {
        this.clientContactCopy = {}
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 100)
      }
      this.showDialog = true
      // if (!this.contactsPickList.length) {
      //   this.gettingContactList = true
      //   this.contactsPickList = await clientsAPI.getCompanyClients()
      //   this.gettingContactList = false
      // }
    },
    async deleteClientContact () {
      this.isDeleting = true
      let tmp = await clientsAPI.removeClientContact(this.clientContactCopy)
      this.contacts = miscServices.removeObject(this.contacts, tmp)
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.isDeleting = false
      this.showConfirmDelete = false
      this.showDialog = false
    },
    openCompany (companyID) {
      this.$router.push({ name: 'ClientOverview', params: { id: companyID } })
    },
    setLoading (val) {
      this.isLoading = val
    }
  },
  components: {
    'client-form-search': ClientFormSearch
  }
}
</script>